import { qb } from "config"
import { LOCAL_STORAGE_TAGS } from "constants/index"
import { get, post } from "helpers/api_helper"

import * as QB from "quickblox/quickblox"

const { CREDENTIALS, CONFIG } = qb

QB.init(
  CREDENTIALS.appId,
  CREDENTIALS.authKey,
  CREDENTIALS.authSecret,
  CREDENTIALS.accountKey,
  CONFIG
)

export const createSession = (login, password) => {
  return new Promise((resolve, reject) => {
    QB.createSession({ login, password }, (error, result) => {
      if (error) {
        reject(error)
      } else {
        resolve(result)
      }
    })
  })
}

export const connectToChat = async (userId, password) => {
  try {
    return new Promise((resolve, reject) => {
      QB.chat.connect({ userId, password }, (error, result) => {
        if (error) {
          reject(error)
        } else {
          resolve(result || true)
        }
      })
    })
  } catch (err) {
    console.error(err)
  }
}

export const reSession = async token => {
  return new Promise((resolve, reject) => {
    QB.startSessionWithToken(token, (err, mySession) => {
      if (err) reject(err)
      else resolve(mySession)
    })
  })
}

export const connectionListener = async (onDisconnect, onReconnect) => {
  QB.chat.onDisconnectedListener = onDisconnect
  QB.chat.onReconnectListener = onReconnect
}

export const connectToDialog = dialogId => {
  return new Promise((resolve, reject) => {
    QB.chat.dialog.list({ _id: dialogId }, (error, dialogs) => {
      if (error) {
        reject(error)
      } else {
        if (dialogs.items.length) {
          const dialog = dialogs.items[0]
          resolve(dialog)
        }
      }
    })
  })
}

export const getDialogs = params => {
  return new Promise((resolve, reject) => {
    const defaultParams = {
      created_at: {
        lt: Date.now() / 1000,
      },
      sort_desc: "created_at",
      limit: 100,
    }
    QB.chat.dialog.list({ ...defaultParams, ...params }, (error, dialogs) => {
      if (error) {
        reject(error)
      } else {
        resolve(dialogs)
      }
    })
  })
}

export const getUnreadMessageCount = dialog_ids => {
  return new Promise((resolve, reject) => {
    let params = {
      chat_dialog_ids: dialog_ids,
    }
    QB.chat.message.unreadCount(params, (error, result) => {
      if (error) {
        reject(error)
      } else {
        resolve(result)
      }
    })
  })
}

export const getMessageWithId = messageId => {
  return new Promise((resolve, reject) => {
    QB.chat.message.list({ ...messageId }, (err, resp) => {
      if (err) reject(err)
      else resolve(resp)
    })
  })
}

export const joinGroupDialog = dialogId => {
  return new Promise((resolve, reject) => {
    QB.chat.muc.join(dialogId, (error, result) => {
      if (error) {
        reject(error)
      } else {
        resolve(result)
      }
    })
  })
}

export const mucConnect = async chatId => {
  await QB.chat.muc.join(chatId, () => {})
}

export const getMessages = (dialog, beforeDateSent) => {
  return new Promise((resolve, reject) => {
    QB.chat.muc.join(dialog.xmpp_room_jid || dialog._id, (error, result) => {
      if (error) {
        reject(error)
      } else {
        QB.chat.message.list(
          beforeDateSent
            ? {
                chat_dialog_id: dialog._id,
                sort_desc: "date_sent",
                limit: 30,
                date_sent: { lt: beforeDateSent },
                // mark_as_read: 0
              }
            : {
                chat_dialog_id: dialog._id,
                sort_desc: "date_sent",
                limit: 30,
              },
          (error, messages) => {
            if (error) {
              reject(error)
            } else {
              resolve(messages)
            }
          }
        )
      }
    })
  })
}

export const getPrivateDialogMessages = (dialog, beforeDateSent) => {
  return new Promise((resolve, reject) => {
    QB.chat.message.list(
      beforeDateSent
        ? {
            chat_dialog_id: dialog._id,
            sort_desc: "date_sent",
            limit: 30,
            date_sent: { lt: beforeDateSent },
            // mark_as_read: 0
          }
        : {
            chat_dialog_id: dialog._id,
            sort_desc: "date_sent",
            limit: 30,
          },
      (error, messages) => {
        if (error) {
          reject(error)
        } else {
          resolve(messages)
        }
      }
    )
  })
}

export const getUserList = async (id, noLimit) => {
  var params = {
    filter: {
      field: "created_at",
      param: "between",
      value: "2024-01-01, 2051-05-06",
    },
    order: {
      field: "created_at",
      sort: "desc",
    },
    per_page: 100,
  }
  if (id) params.filter = { field: "id", param: "in", value: id }
  else if (noLimit) params.per_page = {}
  return new Promise((resolve, reject) => {
    QB.users.listUsers(params, (err, resp) => {
      if (err) reject(err)
      else resolve(resp)
    })
  })
}

export const subscribeToChat = (onMessage, onSystemMessage) => {
  QB.chat.onMessageListener = onMessage
  QB.chat.onSystemMessageListener = onSystemMessage
}

export const sendTextMessageWithType = (dialogRoomId, message, type, jid) => {
  QB.chat.send(jid, {
    type: type,
    body: message,
    extension: {
      likes: false,
      comment: [],
      save_to_history: 1,
      dialog_id: dialogRoomId,
    },
    markable: 1,
  })
}

export const createDialog = userList => {
  var params = {
    type: 3,
    occupants_ids: userList,
  }
  return new Promise((resolve, reject) => {
    QB.chat.dialog.create(params, (err, resp) => {
      if (err) reject(err)
      else resolve(resp)
    })
  })
}

export const markMessageAsRead = (
  last_message_in_chat_id,
  userId,
  chat_dialog_id
) => {
  let params = {
    messageId: last_message_in_chat_id,
    userId: userId,
    dialogId: chat_dialog_id,
  }
  try {
    QB.chat.sendReadStatus(params)
    console.log("sendReadStatus was sent")
  } catch (e) {
    if (e.name === "ChatNotConnectedError") {
      // not connected to chat
    }
  }
}

export const sendTextMessage = (
  dialogRoomJid,
  message,
  dialog_type = 1,
  receiver_ids = [],
  dialog_id
) => {
  return new Promise((resolve, reject) => {
    try {
      const result = QB.chat.send(
        dialog_type === 3 ? receiver_ids[0] : dialogRoomJid,
        {
          type: dialog_type === 3 ? "chat" : "groupchat",
          body: message,
          extension: {
            likes: false,
            comment: [],
            save_to_history: 1,
            attachments: [],
            ...(dialog_type === 3 ? { dialog_id } : {}),
          },
          markable: 1,
        }
      )
      resolve(result)
    } catch (error) {
      reject(error)
    }
  })
}

export const sendMessageWithAttachment = (
  dialogRoomJid,
  inputFile,
  text,
  dialog_type = 1,
  receiver_ids = [],
  dialog_id
) => {
  return new Promise((resolve, reject) => {
    QB.content.createAndUpload(
      {
        name: inputFile.name,
        file: inputFile,
        type: inputFile.type,
        size: inputFile.size,
        public: false,
      },
      (error, result) => {
        if (!error) {
          const message = {
            type: dialog_type === 3 ? "chat" : "groupchat",
            body: !!text ? text : "",
            extension: {
              likes: false,
              comment: [],
              save_to_history: 1,
              dialog_id: dialog_type === 3 ? dialog_id : dialogRoomJid,
              attachments: [
                { id: result?.id, type: result?.content_type?.split("/")[0] },
              ],
            },
          }
          const msg = QB.chat.send(
            dialog_type === 3 ? receiver_ids[0] : dialogRoomJid,
            message
          )
          resolve({
            messageId: msg,
            attachments: [
              { id: result?.id, type: result?.content_type?.split("/")[0] },
            ],
          })
        } else {
          console.error(error)
          reject(error)
        }
      }
    )
  })
}

export const getMessageAttachment = (fileId, token) => {
  return `${QB.content.publicUrl(fileId)}/download.json?token=${token}`
}

export const deleteMessage = async params => {
  try {
    const data = await post("/admin/qb/delete-messages", params)
    console.log("Response data:", data)
    return data // Return the response data if needed
  } catch (error) {
    console.error("Error deleting message:", error)
    throw error
  }
}

export const getNfComments = async filter => {
  return new Promise((resolve, reject) => {
    var className = "Comments"
    QB.data.list(className, filter, function (error, result) {
      if (error) {
        reject(error)
      } else {
        resolve(result.items)
      }
    })
  })
}

export const createRecord = (className = "Comments", data) => {
  return new Promise((resolve, reject) => {
    const record = { ...data, date: new Date().toISOString() }
    QB.data.create(className, record, (error, result) => {
      if (error) {
        reject(error)
      } else {
        resolve(result)
      }
    })
  })
}

export const disconnect = disconnectListener => {
  QB.chat.disconnect()
  QB.chat.onDisconnectedListener = disconnectListener
}
